import React from 'react'
import BlogCards from './BlogCards'

function MainContent() {
  return (
    <div className='w-full flex flex-col items-center'>
      <div className='w-full flex flex-col items-center'>
        <h1 className="text-2xl md:text-3xl font-semibold leading-snug md:leading-normal mb-4 text-dark-1
         dark:text-white">
          Latest News
        </h1>
        <span className='font-sans text-gray-600 dark:text-gray-400'>
          We’re on a mission to deliver engaging, curated courses at a reasonable price.
        </span>
      </div>
      <BlogCards />
    </div>
  )
}

export default MainContent